import { EnvelopeSimple, Clock, MapPin, BookOpen } from "@phosphor-icons/react";
import { useConfig } from "@/hooks/useConfig";
import { SUPPORT_EMAIL } from "@/components/store/LegalPage";

export default function Contact() {
  const { config } = useConfig();
  return (
    <div className="mx-auto max-w-4xl px-5 py-16 sm:px-8 md:py-24" data-testid="contact-page">
      <p className="eyebrow">Contact us</p>
      <h1 className="mt-3 font-display text-3xl leading-tight tracking-tight sm:text-4xl">Write to us — a real person replies.</h1>
      <p className="mt-5 max-w-2xl text-base leading-[1.8] text-foreground/75">
        {config?.store_name || "ShansoBooks"} is run directly by the poet, so there is no call centre between you and us.
        For anything about an order, an address change, a bulk or library order, or a note about the poems themselves, email us and we'll get back to you.
      </p>

      <div className="mt-12 grid gap-5 sm:grid-cols-2">
        <a href={`mailto:${SUPPORT_EMAIL}`} className="group rounded-sm border border-foreground/10 bg-white p-6 transition-colors hover:border-primary" data-testid="contact-email-card">
          <EnvelopeSimple size={22} weight="duotone" className="text-primary" />
          <p className="mt-4 text-xs uppercase tracking-[0.14em] text-muted-foreground">Email</p>
          <p className="mt-1 text-base font-semibold transition-colors group-hover:text-primary" data-testid="contact-email">{SUPPORT_EMAIL}</p>
          <p className="mt-2 text-sm text-muted-foreground">Best for order help, invoices and tracking.</p>
        </a>
        <div className="rounded-sm border border-foreground/10 bg-white p-6">
          <Clock size={22} weight="duotone" className="text-primary" />
          <p className="mt-4 text-xs uppercase tracking-[0.14em] text-muted-foreground">Response time</p>
          <p className="mt-1 text-base font-semibold">Within 1–2 working days</p>
          <p className="mt-2 text-sm text-muted-foreground">Monday to Saturday, 10am–7pm IST.</p>
        </div>
        <div className="rounded-sm border border-foreground/10 bg-white p-6">
          <BookOpen size={22} weight="duotone" className="text-primary" />
          <p className="mt-4 text-xs uppercase tracking-[0.14em] text-muted-foreground">Orders & dispatch</p>
          <p className="mt-1 text-base font-semibold">Quote your order number</p>
          <p className="mt-2 text-sm text-muted-foreground">It starts with “BK” and is in your confirmation email — it helps us answer in one reply.</p>
        </div>
        <div className="rounded-sm border border-foreground/10 bg-white p-6">
          <MapPin size={22} weight="duotone" className="text-primary" />
          <p className="mt-4 text-xs uppercase tracking-[0.14em] text-muted-foreground">Seller</p>
          <p className="mt-1 text-base font-semibold">{config?.store_name || "ShansoBooks"}</p>
          <p className="mt-2 text-sm text-muted-foreground">Books are packed by hand and shipped across India from Tamil Nadu.</p>
        </div>
      </div>

      <p className="mt-12 text-sm text-muted-foreground">
        Please note: all sales are final — see our <a href="/refund-policy" className="font-semibold text-primary hover:underline" data-testid="contact-refund-link">refund policy</a> and{" "}
        <a href="/terms" className="font-semibold text-primary hover:underline" data-testid="contact-terms-link">terms &amp; conditions</a>.
      </p>
    </div>
  );
}
